import { Link } from '@inertiajs/react'
import { useShared } from '../lib/hooks'

export default function Footer() {
  const { site } = useShared()
  const year = new Date().getFullYear()

  return (
    <footer className="mt-24 border-t border-line">
      <div className="mx-auto max-w-[1400px] px-4 sm:px-6 py-10 flex flex-col sm:flex-row sm:items-center justify-between gap-6">
        <div className="flex items-baseline gap-3">
          <span className="font-semibold">Forma Sound</span>
          <span className="mono-label">Serum 2 Preset Packs</span>
        </div>
        <nav className="flex flex-wrap items-center gap-x-6 gap-y-2">
          <Link href="/packs" className="mono-label hover:text-paper transition-colors">Catalog</Link>
          <Link href="/account" className="mono-label hover:text-paper transition-colors">Downloads</Link>
          <Link href="/help" className="mono-label hover:text-paper transition-colors">Help</Link>
          <a href={`mailto:${site.support_email}`} className="mono-label hover:text-paper transition-colors">Support</a>
          <a href="/sitemap.xml" className="mono-label hover:text-paper transition-colors">Sitemap</a>
        </nav>
        <div className="mono-label">
          Forma Sound LLC · {year} · {site.location}
        </div>
      </div>
    </footer>
  )
}
